import { Users } from "lucide-react"
import { useTranslation } from "react-i18next"

/**
 * OKS-473 — Crew Pulse "all quiet" empty state (UX Spec §3). Shown on both the
 * Crew tab root section and the full stream when there's no recent activity —
 * an encouraging illustration + copy, never a blank or an error screen. (The
 * pulse read is non-blocking, so a read FAILURE also renders this, by design.)
 */
export function CrewPulseEmpty() {
  const { t } = useTranslation()

  return (
    <div
      data-testid="crew-pulse-empty"
      className="flex flex-col items-center gap-2 px-6 py-10 text-center"
    >
      <span
        aria-hidden="true"
        className="bg-muted text-muted-foreground mb-1 flex size-12 items-center justify-center rounded-full"
      >
        <Users className="size-6" />
      </span>
      <p className="text-sm font-semibold">{t("crew_pulse.empty.title")}</p>
      <p className="text-muted-foreground max-w-xs text-xs">
        {t("crew_pulse.empty.body")}
      </p>
    </div>
  )
}
